import { render, staticRenderFns } from "./transaction-history.vue?vue&type=template&id=64c56c42&scoped=true"
import script from "./transaction-history.vue?vue&type=script&lang=js"
export * from "./transaction-history.vue?vue&type=script&lang=js"
import style0 from "./transaction-history.vue?vue&type=style&index=0&id=64c56c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c56c42",
  null
  
)

export default component.exports